import { render, staticRenderFns } from "./childrenComponent.vue?vue&type=template&id=778c5cc6&scoped=true"
import script from "./childrenComponent.vue?vue&type=script&lang=js"
export * from "./childrenComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c5cc6",
  null
  
)

export default component.exports